import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

type TreeRowVariant = 'default' | 'highlighted' | 'hoverable' | 'tableRow'

interface TreeRowProps {
    depth: number
    children: ReactNode
    variant?: TreeRowVariant
    indent?: number
    basepadding?: number
    className?: string
    onClick?: () => void
    'data-testid'?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const variantClasses: Record<TreeRowVariant, string> = {
    default: '',
    highlighted: 'py-1.5 px-2 rounded-md bg-primary/10 border border-primary/30',
    hoverable: 'py-1.5 px-2 rounded-md hover:bg-muted/50',
    tableRow: 'hover:bg-muted/30 border-b py-2 pr-3',
}
/* eslint-enable i18next/no-literal-string */

export function TreeRow({
    depth,
    children,
    variant = 'default',
    indent = 24,
    basepadding = 12,
    className,
    onClick,
    'data-testid': testId,
}: TreeRowProps) {
    return (
        <div
            className={cn('flex items-center gap-3', variantClasses[variant], className)}
            style={{paddingLeft: basepadding + depth * indent}}
            onClick={onClick}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
